import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSavedCartDetailsActionComponent } from './saved-cart-details-action.component';
import { AuthGuard, CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CustomExportOrderEntriesModule } from '../../../../import-export/components/export-entries';

@NgModule({
  declarations: [CustomSavedCartDetailsActionComponent],
  imports: [CommonModule, I18nModule, CustomExportOrderEntriesModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SavedCartDetailsActionComponent: {
          component: CustomSavedCartDetailsActionComponent,
          guards: [AuthGuard],
        },
      },
    }),
  ],
})
export class SavedCartDetailsActionModule {}
